
import { createTheme } from '@mui/material/styles';


const theme = createTheme({
  palette: {
    primary: {
      main: '#BE9F55',
    },
    secondary: {
      main: '#6A1B9A',  // Example secondary color
    },
  },

  typography: {
    fontFamily: 'LexendDeca, sans-serif', // Set LexendDeca as default font
  },
});

export default theme;
